import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Passau/teaser-passau.jpg"}/>
                    <figcaption>
                        Quelle: Stadtarchiv Passau
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1952: Passau </p>
                <p className="ort-subheader">
                    <i>„Wir fordern die Vereinigten Staaten von Europa.“</i>
                </p>
                <Link to="/orte/passau/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

